import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  BASE_URL,
  getToken,
  getCurrentLanguage,
} from "../../shared/utils.js/utils";

// Get Currencies
export const getCurrencies = createAsyncThunk(
  "Currencies/getCurrencies",
  async (params = {}, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.per_page) queryParams.append("per_page", params.per_page);
      if (params.search !== undefined)
        queryParams.append("search", params.search);
      if (params.status !== undefined)
        queryParams.append("status", params.status);
      if (params.is_base !== undefined)
        queryParams.append("is_base", params.is_base);
      if (params.sort_by !== undefined)
        queryParams.append("sort_by", params.sort_by);
      if (params.sort_order !== undefined)
        queryParams.append("sort_order", params.sort_order);
      const url = `${BASE_URL}/currencies${queryParams.toString() ? `?${queryParams.toString()}` : ""}`;
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get currencies!";
      return rejectWithValue(message);
    }
  },
);

// Get Currency Details
export const getCurrencyDetails = createAsyncThunk(
  "Currencies/getCurrencyDetails",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.get(`${BASE_URL}/currencies/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to get currency details!";
      return rejectWithValue(message);
    }
  },
);

// Add Currency
export const addCurrency = createAsyncThunk(
  "Currencies/addCurrency",
  async (data, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.post(`${BASE_URL}/currencies`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      let message = error.response?.data?.message || "Failed to add currency!";
      return rejectWithValue(message);
    }
  },
);

// Update Currency
export const updateCurrency = createAsyncThunk(
  "Currencies/updateCurrency",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.put(`${BASE_URL}/currencies/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      let message =
        error.response?.data?.message || "Failed to update currency!";
      return rejectWithValue(message);
    }
  },
);

// Toggle Currency Status
export const toggleCurrencyStatus = createAsyncThunk(
  "Currencies/toggleCurrencyStatus",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.patch(
        `${BASE_URL}/currencies/${id}/toggle-status`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": currentLang,
          },
        },
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to toggle currency status!";
      return rejectWithValue(message);
    }
  },
);

// Delete Currency
export const deleteCurrency = createAsyncThunk(
  "Currencies/deleteCurrency",
  async (id, { rejectWithValue }) => {
    try {
      const token = getToken();
      const currentLang = getCurrentLanguage();
      if (!token) throw new Error("No authentication token found");
      const response = await axios.delete(`${BASE_URL}/currencies/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Accept-Language": currentLang,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to delete currency!";
      return rejectWithValue(message);
    }
  },
);
